<template lang="pug">
include ../pug/svg
section#profile
	<h1>Activity</h1>
</template>

<script>
	
export default {
	name: 'ManagePeopleUserActivity',
	props: ['cancelled'],
	emits: ['storeUpdated'],
	components: {
	},
	data() {		
		return {
		};
	},
	mounted() {
		this.$store.dispatch('gui/setHeader', {
			title: 'Activity2',
			backRoute: {
				text: 'Dashboard',
				name: 'Dashboard',
			},			
		});
	},
	computed: {
	},
	watch: {
		cancelled: {
			// parent triggered cancel
			handler(val) {
				if (!val) { // store reset complete
					const form = this.$refs.profileForm;
					const errors = form.getErrors();
					
					for(const field in form.getValues()) {
						form.setFieldTouched(field, false);
						
						if (field in errors) {
							form.setFieldError(field, '-');					
						}
					}
				}
			},
			deep: true,
		},
	},
	methods: {
	},
}
</script>

<style lang="scss">
#profile {
	.err {
		transition: opacity .3s .0s ease-in-out; // delay on appear
		&.hide {
			opacity: 0;
		}
	}
	.wrapper {
		position: relative;
		display: flex;
		align-items: flex-start;
		margin-top: 30px;
	}
	.c1 {
		width: 230px;
		min-width: 230px;
	}
	.c2 {
		flex-grow: 1;
		display: flex;
		flex-wrap: wrap;
		.field {
			margin: 0 0 25px 15px;
		}
		&:not(.dynamic):before {
			content: '';
			display: block;
			height: 60px;
			margin-bottom: 25px;
			width: 100%;
		}
	}
	@media screen and (max-width: 519px) {
		.dynamic {
			position: relative;
			.field {
				margin-left: 0;
			}
		}
		.field {
			width: 100% !important;
		}
		.profile {
			margin-left: auto;
			margin-right: auto;
		}
	}
	@media screen and (min-width: 520px) {
		.dynamic {
			position: absolute;
			top: 0;
			left: 230px;
			right: 0;
		}
	}
	@media screen and (max-width: 759px) {
		.c1 {
			width: 100%;
			.field:not(.profile) {
				max-width: none;
			}
		}		
		.c2:not(.dynamic) {
			justify-content: space-between;
			&:before {
				display: none;
			}
			.field {
				margin-left: 0;
				max-width: none;
				width: calc(50% - 10px);
			}
		}
		form {
			flex-direction: column;
		}
	}
	@media screen and (min-width: 760px) and (max-width: 1264px) {
		.c2:not(.dynamic) {
			margin-top: 85px;
			&:before {
				width: 50%;
			}
		}
		.c2 .field {
			width: calc(50% - 15px);
		}
	}
	@media screen and (min-width: 1265px) {
		.c2 .field {
			width: calc(33.33% - 15px);
		}
	}
}
</style>
